import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';

export const useMoveToSetting = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(() => {
    openDeeplink('ably://setting');
  }, [openDeeplink]);
};
